import {ModalsActionsContext} from 'modules/reports/contexts/modals'
import {useContext} from 'react'

function useModal() {
  return useContext(ModalsActionsContext)
}

export default useModal
